import {
	PagedDialog, Button, Checkbox, H3, Text
} from '@components';
import { ACCESS_LEVELS, BUTTON_SIZE, TRateCard } from '@types';
import styles from './ReorderShipment.module.scss';
import { formatPriceToFinancial } from '@utils';
import { useState } from 'react';
import { authenticatedUser } from '@state/User';
import { useRecoilValue } from 'recoil';

type TProps = {
	priceData: TRateCard | null;
	isReorderLoading: boolean;
	reorderShipment: () => null | undefined;
	hasDropOffDateError?: boolean;
}

export const Footer = (props: TProps) => {
	const { priceData, isReorderLoading, reorderShipment, hasDropOffDateError = false } = props;
	const [confirmedDetails, setConfirmedDetails] = useState(false);
	const authUser = useRecoilValue(authenticatedUser);
	const roleHasPrice = (): boolean => {
		const accessLevel = authUser?.team?.access_level ?? ACCESS_LEVELS.GUEST;
		return (accessLevel <= ACCESS_LEVELS.TEAM);
	}
	return (
		<PagedDialog.Footer>
			<div className={styles.footerContainer}>
				{priceData && (
					<div className={styles.priceContainer}>
						<div className={styles.row}>
							{
								roleHasPrice() && <>
									<Text>Total Price</Text>
									<H3>${formatPriceToFinancial(priceData.totalPrice)}</H3>
								</>
							}
						</div>
						<Checkbox
							name={'confirmedDetails'}
							label={'I have reviewed and confirm all shipment details are correct'}
							onChange={(e) => setConfirmedDetails(e.target.checked)}
							checked={confirmedDetails && !hasDropOffDateError}
							value={confirmedDetails ? 'yes' : 'no'}
							disabled={hasDropOffDateError}
						/>
					</div>
				)}
				<Button
					text={'Submit Order'}
					onClick={reorderShipment}
					size={BUTTON_SIZE.SMALL}
					disabled={!priceData || !confirmedDetails || hasDropOffDateError}
					loading={isReorderLoading}
				/>
			</div>
		</PagedDialog.Footer>
	);
}
Footer.displayName = 'Footer';
